import Header from "../components/Header";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import projects from "../assets/projects.json";
import ProjectCard from "../components/ProjectCard";
import "./Projects.css";

const data = {
  heading: "Projects",
  image: "/images/projects.svg",
};

const Projects = ({ match }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Header heading={data.heading} image={data.image} />
      <div className="projects-wrapper">
        {projects.projects.map((project) => (
          <ProjectCard project={project} />
        ))}
      </div>
      <Link to="/" className="home">
        Home
      </Link>
    </motion.div>
  );
};

export default Projects;
